module.exports = __webpack_public_path__ + "static/media/vasterbron.e23ba3a7.png";